import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/store/modules/auth';

import attachments from '@/store/modules/attachments';

import banks from '@/store/modules/banks';
import banksIntegrated from '@/store/modules/banks-integrated';
import banksWeb from '@/store/modules/banks-web';

import customers from '@/store/modules/customers';

import domains from '@/store/modules/domains';
import domainsWeb from '@/store/modules/domains-web';

import financingReturnRules from '@/store/modules/financing-return-rules';
import returnDomains from '@/store/modules/return-domains';

import financingProductRules from '@/store/modules/financing-product-rules';

import leads from '@/store/modules/leads';

import proposals from '@/store/modules/proposals';
import proposalAttempts from '@/store/modules/proposal-attempts';
import proposalComments from '@/store/modules/proposal-comments';

import simulations from '@/store/modules/simulations';

import stores from '@/store/modules/stores';
import sellers from '@/store/modules/sellers';

import toasts from '@/store/modules/toasts';

import vehicleModels from '@/store/modules/vehicle-models';
import vehicleFilters from '@/store/modules/vehicle-filters';
import vehiclePrices from '@/store/modules/vehicle-prices';
import vehicles from '@/store/modules/vehicles';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,

    attachments,

    banks,
    banksIntegrated,
    banksWeb,

    customers,

    domains,
    domainsWeb,

    financingReturnRules,
    returnDomains,
    financingProductRules,

    leads,

    proposals,
    proposalAttempts,
    proposalComments,

    simulations,

    stores,
    sellers,

    toasts,

    vehicleModels,
    vehicleFilters,
    vehiclePrices,
    vehicles,
  },
});
